var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useContext } from "react";
import { SiteSidebarContext } from "../context/site-sidebar-context";
import { useEnv } from "./use-env";
export var useSiteSidebar = function () {
  var context = useContext(SiteSidebarContext);
  var env = useEnv();
  var baseConfig = {
    showFullscreenButton: false,
    color: env.SITE_SIDEBAR_COLOR,
    width: env.SITE_SIDEBAR_WIDTH,
    widthMenu: env.SITE_SIDEBAR_MENU_WIDTH,
    isAvailable: function () {
      return false;
    }
  };
  var config = __assign(__assign({}, baseConfig), context);
  var color = config.color,
    width = config.width,
    widthMenu = config.widthMenu,
    buttons = config.buttons,
    isAvailable = config.isAvailable,
    onClick = config.onClick;
  return {
    color: color,
    isAvailable: isAvailable,
    showFullscreenButton: !!context.showFullscreenButton,
    widthMenu: widthMenu,
    width: width,
    buttons: buttons,
    onClick: onClick
  };
};